import { PERMISSIONS } from '@/enums/permissions'

export default [{
  title: 'Financeiro',
  route: 'financial',
  icon: 'TrendingUpIcon',
  permissions: [PERMISSIONS.FINANCEIRO],
},
{
  title: 'Integração',
  route: 'integration',
  icon: 'FolderIcon',
  permissions: [PERMISSIONS.INTEGRACAO],
},
{
  title: 'Cobrança',
  route: 'cobrança',
  icon: 'DollarSignIcon',
  permissions: [PERMISSIONS.COBRANCA],
  children: [{
    title: 'Nova Cobrança',
    route: 'New-Charging',
    permissions: [PERMISSIONS.COBRANCA],
  },
  {
    title: 'Minhas Cobranças',
    route: 'myCharging',
    permissions: [PERMISSIONS.COBRANCA],
  },
  ],
},
{
  title: 'Clientes',
  route: 'clientes',
  icon: 'UsersIcon',
  permissions: [PERMISSIONS.CLIENTES],
},
// {
//   title: 'Relatorios',
//   icon: 'FileTextIcon',
//   permissions: [PERMISSIONS.RELATORIOS],
//   children: [{
//     title: 'Transação',
//     icon: 'SidebarIcon',
//     route: 'relatorioTransacao',
//     permissions: [PERMISSIONS.RELATORIOS],
//   },
//   {
//     title: 'Recorrência',
//     icon: 'EditIcon',
//     route: 'relatorioRecorrencia',
//     permissions: [PERMISSIONS.RELATORIOS],
//   },
//   {
//     title: 'Boletos',
//     icon: 'ShoppingBagIcon',
//     route: 'relatorioBoleto',
//     permissions: [PERMISSIONS.RELATORIOS],
//   },
//   {
//     title: 'Grupo',
//     icon: 'UsersIcon',
//     route: 'relatorioGrupo',
//     permissions: [PERMISSIONS.RELATORIOS],
//   },
//   ],
// },
{
  title: 'Soluções',
  icon: 'ArchiveIcon',
  tagVariant: 'light-danger',
  route: 'products',
  permissions: [PERMISSIONS.SOLUCOES],
},
{
  title: 'Permissões',
  route: 'permission-management',
  icon: 'ShieldIcon',
  permissions: [PERMISSIONS.MASTER, PERMISSIONS.ADMIN],
},
{
  title: 'Fale conosco',
  route: 'faleConosco',
  icon: 'PhoneIcon',
},
]
